/* Public API Surface of client-search */

/// <reference types="@angular/localize" />

export { provideClientSearchLib } from './lib/clients-search-lib.provider';
export { ClientsSearchDialogComponent } from './lib/components/clients-search-dialog/clients-search-dialog.component';
export { ClientsSearchTableComponent } from './lib/components/clients-search-table/clients-search-table.component';
export { CLIENTS_SEARCH_CONSTANTS } from './lib/core/constants/clients-search.constants';
export { IClientDto } from './lib/core/models/client.dto';
export { ClientsSearchApiInfo } from './lib/core/services/api/clients-search-api-Info';
